import { gql } from "@apollo/client";

export type SignStatus = "NOT_SIGNED" | "SIGNED_ONLINE" | "SIGNED_OFFLINE";

export interface TermsOfServiceStatus {
  sign_status: SignStatus;
  reminder_time: string | null;
}

export interface TermsOfServiceStatusResponse {
  terms_of_service_status: TermsOfServiceStatus | null;
}

export interface TermsOfServiceLatestVersion {
  id: string;
  version: string;
  file: string;
  created_time: string;
}

export interface TermsOfServiceLatestVersionResponse {
  terms_of_service_latest_version: TermsOfServiceLatestVersion | null;
}

export interface SetTermsStatusVariables {
  set_sign: boolean;
  set_reminder: boolean;
  terms_version: string;
}

export interface SetTermsStatusResponse {
  set_terms_status: {
    msg: string;
  } | null;
}

export const TERMS_OF_SERVICE_STATUS = gql`
  query terms_of_service_status {
    terms_of_service_status {
      sign_status
      reminder_time
    }
  }
`;

export const TERMS_OF_SERVICE_LATEST_VERSION = gql`
  query terms_of_service_latest_version {
    terms_of_service_latest_version {
      id
      version
      file
      created_time
    }
  }
`;

export const SET_TERMS_STATUS = gql`
  mutation set_terms_status(
    $set_sign: Boolean!
    $set_reminder: Boolean!
    $terms_version: String!
  ) {
    set_terms_status(
      set_sign: $set_sign
      set_reminder: $set_reminder
      terms_version: $terms_version
    ) {
      msg
    }
  }
`;
